// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Styles spécifiques à TabDocuments
 * Complète MesDocuments.css pour la section Logo
 * FRONT-21: Styles pour les chapitres thématiques de documents
 */

/* =========================================
   FRONT-21: Chapitres de documents
   ========================================= */

/* Grand chapitre */
.document-chapter {
  margin-bottom: 3rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: visible;
}

.chapter-header {
  background-color: #595959; /* Gris foncé - comme avant */
  color: #ffffff;
  padding: 1.25rem 1.5rem;
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}

.chapter-description {
  padding: 0.75rem 1.5rem;
  font-size: 1.3rem;
  font-style: italic;
  color: #6b7280;
  background-color: #f9fafb;
}

.chapter-content {
  /* padding retire : SectionPliable porte deja le padding 1.5rem du corps. */
  padding: 0;
}

.chapter-content--grid4 {
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  gap: 1.25rem;
  align-items: stretch;
}

/* Profil pleine page : forcer 8 colonnes même si ModalProfilMembre.css est chargé */
.profil-container .chapter-content--grid4 {
  grid-template-columns: repeat(8, 1fr);
}

/* Sous-chapitre (section document) */
.document-section {
  margin-bottom: 0;
  border-radius: 0.375rem;
  overflow: visible;
}

.section-header {
  background-color: #595959; /* Gris foncé avec bandeau */
  color: #ffffff;
  padding: 0.75rem 1rem;
  font-weight: 600;
  font-size: 1.4rem;
  margin: 0;
  position: relative;
}

.section-note {
  background-color: #f3f4f6; /* Gris fond */
  color: #374151; /* Gris texte */
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
  font-style: italic;
  border-bottom: 1px solid #e5e7eb;
}

.document-section > .section-content {
  padding: 1rem;
  background-color: #ffffff;
  padding: 2rem;
}

.section-content--empty {
  background-color: #f9fafb !important;
}

/* Messages informatifs en italique */
.info-message {
  display: block;
  font-size: 1.3rem;
  color: #6b7280;
  font-style: italic;
  padding: 0.75rem 0;
  text-align: right;
}

/* =========================================
   Section Logo entreprise
   ========================================= */

.logo-section-container {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.logo-preview-box {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  border: 2px dashed #d7d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fafafa;
  overflow: hidden;
  flex-shrink: 0;
}

.logo-preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.logo-preview-text {
  color: #999;
  font-size: 1.2rem;
  text-align: center;
  padding: 0.5rem;
}

.logo-info-container {
  flex: 1 1;
  min-width: 200px;
}

.logo-info-text {
  margin: 0 0 0.5rem 0;
  font-size: 1.3rem;
  color: #666;
}

.logo-info-text:last-of-type {
  margin-bottom: 1rem;
}

.logo-error-text {
  margin: 0 0 1rem 0;
  font-size: 1.2rem;
  color: #dc2626;
  font-weight: 500;
}

.logo-buttons-container {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

/* =========================================
   Responsive
   ========================================= */

@media (max-width: 480px) {
  .logo-section-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .logo-preview-box {
    width: 80px;
    height: 80px;
  }

  .logo-info-container {
    width: 100%;
  }

  .logo-buttons-container {
    flex-direction: column;
    width: 100%;
  }

  .logo-buttons-container button {
    width: 100%;
  }
}

/* =========================================
   Astérisque obligatoire
   ========================================= */

.document-section .section-content .subsection-header .required-asterisk {
  position: absolute;
  top: 0rem;
  right: 0rem;
  color: #dc2626;
  font-weight: bold;
  margin-left: 0;
}

/* =========================================
   CORE-12: Message document non modifiable
   ========================================= */

.document-locked-message {
  display: block;
  font-size: 1.3rem;
  color: #6b7280;
  font-style: italic;
  padding: 0.75rem 0;
  text-align: right;
}

.subsection-header {
  font-size: 1.4rem;
  position: relative;
}

/* Tooltip fixe au survol de section - passe au-dessus de tout */
.section-note-tooltip--fixed {
  position: fixed;
  transform: translateX(-50%) translateY(calc(-100% - 10px));
  background: #1f2937;
  color: #f9fafb;
  font-size: 1.1rem;
  font-weight: 400;
  font-style: normal;
  line-height: 1.4;
  padding: 0.5rem 0.75rem;
  border-radius: 0.4rem;
  white-space: normal;
  width: max-content;
  max-width: 240px;
  z-index: 99999;
  pointer-events: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

.section-note-tooltip--fixed::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 5px solid transparent;
  border-top-color: #1f2937;
}

.document-section > .section-content {
  border-radius: 10px;
}

.document-chapter > .chapter-header,
.document-chapter {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

/* =========================================
   Cards document redesign (prestataire)
   ========================================= */

.doc-section-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: stretch;
  padding: 0.25rem 0 0.5rem;
}

/* Carte document existant */
.doc-file-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  min-width: 220px;
  max-width: 360px;
  flex: 1 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition:
    box-shadow 0.15s ease,
    border-color 0.15s ease;
}

.doc-file-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: #d1d5db;
}

.doc-file-card-icon {
  width: 38px;
  height: 38px;
  background: #fff7ed;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #f97316;
}

.doc-file-card-icon svg {
  width: 20px;
  height: 20px;
}

.doc-file-card-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.doc-file-card-name {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doc-file-card-date {
  font-size: 1.1rem;
  color: #9ca3af;
}

.doc-file-card-download {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background 0.15s ease,
    color 0.15s ease;
  flex-shrink: 0;
}

.doc-file-card-download:hover:not(:disabled) {
  background: #fff7ed;
  color: #f97316;
}

.doc-file-card-download:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Carte "+" pour ajouter / mettre à jour */
.doc-add-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 1rem 1.5rem;
  min-width: 110px;
  min-height: 76px;
  background: #ffffff;
  border: 2px dashed #e5e7eb;
  border-radius: 0.75rem;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;
  color: #9ca3af;
  font-family: inherit;
}

.doc-add-card:hover:not(:disabled) {
  border-color: #f97316;
  background: #fff7ed;
  color: #f97316;
}

.doc-add-card:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.doc-add-card-plus {
  font-size: 2.2rem;
  font-weight: 300;
  line-height: 1;
}

.doc-add-card-label {
  font-size: 1.15rem;
  font-weight: 500;
  text-align: center;
  line-height: 1.3;
}

/* État vide */
.doc-empty-text {
  font-size: 1.3rem;
  color: #9ca3af;
  font-style: italic;
  align-self: center;
  padding: 0.5rem 0;
}

@media (max-width: 480px) {
  .doc-file-card {
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }

  .doc-add-card {
    width: 100%;
  }
}

.document-section > .section-content > .documents-list {
  margin: 0 !important;
}

.document-section > .section-content > .documents-list > .documents-grid {
  margin: 0 !important;
}

.document-section > .section-content {
  gap: 0 !important;
}

/* Dans la grille 4 colonnes : centrage titre + carte prend toute la colonne */
.chapter-content--grid4 .section-header,
.chapter-content--grid4 .subsection-header {
  text-align: center !important;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  min-height: 6.5rem;
  gap: 0;
}

.chapter-content--grid4 .document-add-card,
.chapter-content--grid4 .logo-card {
  flex: 1 1;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  height: auto;
  min-height: 72px;
  aspect-ratio: unset;
  align-self: stretch;
  box-sizing: border-box;
}

/* Dans grid4 : 1 doc par cellule, pas de grid interne */
.chapter-content--grid4 .documents-grid {
  display: block !important;
  width: 100%;
  min-width: 0;
  flex: 1 1;
}

/* Sections AC (contrats, CCTP) : pleine largeur dans la grille */
.chapter-content--grid4 .document-section--full-width {
  grid-column: 1 / -1;
}

/* Réduire le padding interne pour les colonnes étroites */
.chapter-content--grid4 .section-content {
  padding: 0.75rem 0.5rem !important;
}

/* Chaîne flex-colonne : chaque niveau s'étire pour remplir la ligne de grille */
.chapter-content--grid4 .document-section {
  display: flex;
  flex-direction: column;
  min-width: 0;
  align-self: stretch;
}

.chapter-content--grid4 .section-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.chapter-content--grid4 .documents-list {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

/* Cartes document : layout vertical, occupe tout l'espace disponible */
.chapter-content--grid4 .document-card,
.chapter-content--grid4 .document-add-card {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.4rem;
  padding: 1rem 0.5rem;
  flex: 1 1 !important;
  width: 100% !important;
  min-width: 0;
  max-width: 100% !important;
  min-height: 72px;
  max-height: unset !important;
  height: 100% !important;
  aspect-ratio: unset !important;
  box-sizing: border-box;
  align-self: stretch;
}

.chapter-content--grid4 .document-card-icon {
  display: none;
}

.chapter-content--grid4 .document-card-icon svg {
  display: none;
}

/* Skeleton grid4 : sans icône, juste la ligne date centrée */
.chapter-content--grid4 .doc-skeleton-icon {
  display: none;
}

.chapter-content--grid4 .document-card-skeleton {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  width: 100%;
}

.chapter-content--grid4 .doc-skeleton-body {
  width: 100%;
  align-items: center;
}

.chapter-content--grid4 .doc-skeleton-line--title {
  display: none;
}

.chapter-content--grid4 .doc-skeleton-line--date {
  width: 70%;
  height: 11px;
}

.chapter-content--grid4 .document-card-body {
  align-items: center;
  gap: 0.15rem;
  flex: 0 0 auto;
}

.chapter-content--grid4 .document-card-type {
  font-size: 1.1rem;
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
  line-height: 1.3;
}

.chapter-content--grid4 .document-card-date {
  font-size: 1rem;
}

.chapter-content--grid4 .document-card-download {
  margin-top: 0.25rem;
}

/* Carte "+" : pleine largeur dans sa cellule, hauteur = hauteur du flex parent */
.chapter-content--grid4 .document-add-card {
  aspect-ratio: unset;
  flex: 1 1;
  height: auto;
  min-height: 72px;
  padding: 1rem 0.5rem;
}

/* =========================================
   Contrats AC groupés par lot
   ========================================= */

.contrats-lot-group {
  margin-bottom: 1.5rem;
}

.contrats-lot-group:last-child {
  margin-bottom: 0;
}

.contrats-lot-header {
  font-size: 1.3rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 0.75rem 0;
  padding-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Lien "Voir les départements/régions" */
.lot-zones-link {
  background: none;
  border: none;
  color: #f97316;
  font-size: 1.2rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  white-space: nowrap;
}

.lot-zones-link:hover {
  color: #ea580c;
}

/* Modale zones géographiques */
.lot-zones-modal {
  background: #ffffff;
  border-radius: 0.75rem;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.lot-zones-modal-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0 0 0.5rem 0;
}

.lot-zones-modal-subtitle {
  font-size: 1.3rem;
  color: #6b7280;
  margin: 0 0 1.5rem 0;
  font-style: italic;
}

.lot-zones-list {
  list-style: none;
  padding: 0;
  margin: 0 0 1.5rem 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5rem;
}

.lot-zones-item {
  font-size: 1.3rem;
  color: #374151;
  padding: 0.5rem 0.75rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
}

.lot-zones-modal-actions {
  display: flex;
  justify-content: flex-end;
}

.contrats-lot-departements {
  font-size: 1.2rem;
  color: #6b7280;
  margin: 0 0 0.75rem 0;
  line-height: 1.5;
}


.document-section .section-content {
  border: 1px solid #e5e7eb;
} `, "",{"version":3,"sources":["webpack://./src/pages/Profil/tabs/TabDocuments.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;8CAE8C;;AAE9C,mBAAmB;AACnB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,6BAA6B;EACxD,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2EAA2E;EAC3E,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,oBAAoB;AACtB;;AAEA,oFAAoF;AACpF;EACE,qCAAqC;AACvC;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,cAAc;EACzC,cAAc,EAAE,eAAe;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;8CAE8C;;AAE9C;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;8CAE8C;;AAE9C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;8CAE8C;;AAE9C;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,0DAA0D;EAC1D,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;8CAE8C;;AAE9C;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;EACP,yCAAyC;EACzC;;2BAEyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;oBAEkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf;;;oBAGkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,8EAA8E;AAC9E;;EAEE,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;AACR;;AAEA;;EAEE,SAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,SAAO;AACT;;AAEA,iEAAiE;AACjE;EACE,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,kCAAkC;AACpC;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;;EAEE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,oBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,6DAA6D;AAC7D;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,mBAAmB;EACnB,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;8CAE8C;;AAE9C;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;;AAGA;EACE,yBAAyB;AAC3B","sourcesContent":["/**\n * Styles spécifiques à TabDocuments\n * Complète MesDocuments.css pour la section Logo\n * FRONT-21: Styles pour les chapitres thématiques de documents\n */\n\n/* =========================================\n   FRONT-21: Chapitres de documents\n   ========================================= */\n\n/* Grand chapitre */\n.document-chapter {\n  margin-bottom: 3rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  overflow: visible;\n}\n\n.chapter-header {\n  background-color: #595959; /* Gris foncé - comme avant */\n  color: #ffffff;\n  padding: 1.25rem 1.5rem;\n  font-size: 1.6rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.chapter-description {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.3rem;\n  font-style: italic;\n  color: #6b7280;\n  background-color: #f9fafb;\n}\n\n.chapter-content {\n  /* padding retire : SectionPliable porte deja le padding 1.5rem du corps. */\n  padding: 0;\n}\n\n.chapter-content--grid4 {\n  display: grid;\n  grid-template-columns: repeat(8, 1fr);\n  gap: 1.25rem;\n  align-items: stretch;\n}\n\n/* Profil pleine page : forcer 8 colonnes même si ModalProfilMembre.css est chargé */\n.profil-container .chapter-content--grid4 {\n  grid-template-columns: repeat(8, 1fr);\n}\n\n/* Sous-chapitre (section document) */\n.document-section {\n  margin-bottom: 0;\n  border-radius: 0.375rem;\n  overflow: visible;\n}\n\n.section-header {\n  background-color: #595959; /* Gris foncé avec bandeau */\n  color: #ffffff;\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n  font-size: 1.4rem;\n  margin: 0;\n  position: relative;\n}\n\n.section-note {\n  background-color: #f3f4f6; /* Gris fond */\n  color: #374151; /* Gris texte */\n  padding: 0.5rem 1rem;\n  font-size: 1.2rem;\n  font-style: italic;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.document-section > .section-content {\n  padding: 1rem;\n  background-color: #ffffff;\n  padding: 2rem;\n}\n\n.section-content--empty {\n  background-color: #f9fafb !important;\n}\n\n/* Messages informatifs en italique */\n.info-message {\n  display: block;\n  font-size: 1.3rem;\n  color: #6b7280;\n  font-style: italic;\n  padding: 0.75rem 0;\n  text-align: right;\n}\n\n/* =========================================\n   Section Logo entreprise\n   ========================================= */\n\n.logo-section-container {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  flex-wrap: wrap;\n}\n\n.logo-preview-box {\n  width: 100px;\n  height: 100px;\n  border-radius: 8px;\n  border: 2px dashed #d7d9d9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fafafa;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.logo-preview-image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.logo-preview-text {\n  color: #999;\n  font-size: 1.2rem;\n  text-align: center;\n  padding: 0.5rem;\n}\n\n.logo-info-container {\n  flex: 1;\n  min-width: 200px;\n}\n\n.logo-info-text {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.3rem;\n  color: #666;\n}\n\n.logo-info-text:last-of-type {\n  margin-bottom: 1rem;\n}\n\n.logo-error-text {\n  margin: 0 0 1rem 0;\n  font-size: 1.2rem;\n  color: #dc2626;\n  font-weight: 500;\n}\n\n.logo-buttons-container {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* =========================================\n   Responsive\n   ========================================= */\n\n@media (max-width: 480px) {\n  .logo-section-container {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .logo-preview-box {\n    width: 80px;\n    height: 80px;\n  }\n\n  .logo-info-container {\n    width: 100%;\n  }\n\n  .logo-buttons-container {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .logo-buttons-container button {\n    width: 100%;\n  }\n}\n\n/* =========================================\n   Astérisque obligatoire\n   ========================================= */\n\n.document-section .section-content .subsection-header .required-asterisk {\n  position: absolute;\n  top: 0rem;\n  right: 0rem;\n  color: #dc2626;\n  font-weight: bold;\n  margin-left: 0;\n}\n\n/* =========================================\n   CORE-12: Message document non modifiable\n   ========================================= */\n\n.document-locked-message {\n  display: block;\n  font-size: 1.3rem;\n  color: #6b7280;\n  font-style: italic;\n  padding: 0.75rem 0;\n  text-align: right;\n}\n\n.subsection-header {\n  font-size: 1.4rem;\n  position: relative;\n}\n\n/* Tooltip fixe au survol de section - passe au-dessus de tout */\n.section-note-tooltip--fixed {\n  position: fixed;\n  transform: translateX(-50%) translateY(calc(-100% - 10px));\n  background: #1f2937;\n  color: #f9fafb;\n  font-size: 1.1rem;\n  font-weight: 400;\n  font-style: normal;\n  line-height: 1.4;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.4rem;\n  white-space: normal;\n  width: max-content;\n  max-width: 240px;\n  z-index: 99999;\n  pointer-events: none;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);\n}\n\n.section-note-tooltip--fixed::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border: 5px solid transparent;\n  border-top-color: #1f2937;\n}\n\n.document-section > .section-content {\n  border-radius: 10px;\n}\n\n.document-chapter > .chapter-header,\n.document-chapter {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n/* =========================================\n   Cards document redesign (prestataire)\n   ========================================= */\n\n.doc-section-cards {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: stretch;\n  padding: 0.25rem 0 0.5rem;\n}\n\n/* Carte document existant */\n.doc-file-card {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.75rem;\n  min-width: 220px;\n  max-width: 360px;\n  flex: 1;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  transition:\n    box-shadow 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.doc-file-card:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  border-color: #d1d5db;\n}\n\n.doc-file-card-icon {\n  width: 38px;\n  height: 38px;\n  background: #fff7ed;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #f97316;\n}\n\n.doc-file-card-icon svg {\n  width: 20px;\n  height: 20px;\n}\n\n.doc-file-card-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.doc-file-card-name {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.doc-file-card-date {\n  font-size: 1.1rem;\n  color: #9ca3af;\n}\n\n.doc-file-card-download {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 6px;\n  color: #9ca3af;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition:\n    background 0.15s ease,\n    color 0.15s ease;\n  flex-shrink: 0;\n}\n\n.doc-file-card-download:hover:not(:disabled) {\n  background: #fff7ed;\n  color: #f97316;\n}\n\n.doc-file-card-download:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Carte \"+\" pour ajouter / mettre à jour */\n.doc-add-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 1rem 1.5rem;\n  min-width: 110px;\n  min-height: 76px;\n  background: #ffffff;\n  border: 2px dashed #e5e7eb;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition:\n    border-color 0.15s ease,\n    background 0.15s ease,\n    color 0.15s ease;\n  color: #9ca3af;\n  font-family: inherit;\n}\n\n.doc-add-card:hover:not(:disabled) {\n  border-color: #f97316;\n  background: #fff7ed;\n  color: #f97316;\n}\n\n.doc-add-card:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.doc-add-card-plus {\n  font-size: 2.2rem;\n  font-weight: 300;\n  line-height: 1;\n}\n\n.doc-add-card-label {\n  font-size: 1.15rem;\n  font-weight: 500;\n  text-align: center;\n  line-height: 1.3;\n}\n\n/* État vide */\n.doc-empty-text {\n  font-size: 1.3rem;\n  color: #9ca3af;\n  font-style: italic;\n  align-self: center;\n  padding: 0.5rem 0;\n}\n\n@media (max-width: 480px) {\n  .doc-file-card {\n    max-width: 100%;\n    min-width: 0;\n    width: 100%;\n  }\n\n  .doc-add-card {\n    width: 100%;\n  }\n}\n\n.document-section > .section-content > .documents-list {\n  margin: 0 !important;\n}\n\n.document-section > .section-content > .documents-list > .documents-grid {\n  margin: 0 !important;\n}\n\n.document-section > .section-content {\n  gap: 0 !important;\n}\n\n/* Dans la grille 4 colonnes : centrage titre + carte prend toute la colonne */\n.chapter-content--grid4 .section-header,\n.chapter-content--grid4 .subsection-header {\n  text-align: center !important;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n  min-height: 6.5rem;\n  gap: 0;\n}\n\n.chapter-content--grid4 .document-add-card,\n.chapter-content--grid4 .logo-card {\n  flex: 1 1 0;\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  height: auto;\n  min-height: 72px;\n  aspect-ratio: unset;\n  align-self: stretch;\n  box-sizing: border-box;\n}\n\n/* Dans grid4 : 1 doc par cellule, pas de grid interne */\n.chapter-content--grid4 .documents-grid {\n  display: block !important;\n  width: 100%;\n  min-width: 0;\n  flex: 1;\n}\n\n/* Sections AC (contrats, CCTP) : pleine largeur dans la grille */\n.chapter-content--grid4 .document-section--full-width {\n  grid-column: 1 / -1;\n}\n\n/* Réduire le padding interne pour les colonnes étroites */\n.chapter-content--grid4 .section-content {\n  padding: 0.75rem 0.5rem !important;\n}\n\n/* Chaîne flex-colonne : chaque niveau s'étire pour remplir la ligne de grille */\n.chapter-content--grid4 .document-section {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  align-self: stretch;\n}\n\n.chapter-content--grid4 .section-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.chapter-content--grid4 .documents-list {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Cartes document : layout vertical, occupe tout l'espace disponible */\n.chapter-content--grid4 .document-card,\n.chapter-content--grid4 .document-add-card {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 0.4rem;\n  padding: 1rem 0.5rem;\n  flex: 1 1 0% !important;\n  width: 100% !important;\n  min-width: 0;\n  max-width: 100% !important;\n  min-height: 72px;\n  max-height: unset !important;\n  height: 100% !important;\n  aspect-ratio: unset !important;\n  box-sizing: border-box;\n  align-self: stretch;\n}\n\n.chapter-content--grid4 .document-card-icon {\n  display: none;\n}\n\n.chapter-content--grid4 .document-card-icon svg {\n  display: none;\n}\n\n/* Skeleton grid4 : sans icône, juste la ligne date centrée */\n.chapter-content--grid4 .doc-skeleton-icon {\n  display: none;\n}\n\n.chapter-content--grid4 .document-card-skeleton {\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  width: 100%;\n}\n\n.chapter-content--grid4 .doc-skeleton-body {\n  width: 100%;\n  align-items: center;\n}\n\n.chapter-content--grid4 .doc-skeleton-line--title {\n  display: none;\n}\n\n.chapter-content--grid4 .doc-skeleton-line--date {\n  width: 70%;\n  height: 11px;\n}\n\n.chapter-content--grid4 .document-card-body {\n  align-items: center;\n  gap: 0.15rem;\n  flex: 0 0 auto;\n}\n\n.chapter-content--grid4 .document-card-type {\n  font-size: 1.1rem;\n  white-space: normal;\n  overflow: visible;\n  text-overflow: unset;\n  line-height: 1.3;\n}\n\n.chapter-content--grid4 .document-card-date {\n  font-size: 1rem;\n}\n\n.chapter-content--grid4 .document-card-download {\n  margin-top: 0.25rem;\n}\n\n/* Carte \"+\" : pleine largeur dans sa cellule, hauteur = hauteur du flex parent */\n.chapter-content--grid4 .document-add-card {\n  aspect-ratio: unset;\n  flex: 1;\n  height: auto;\n  min-height: 72px;\n  padding: 1rem 0.5rem;\n}\n\n/* =========================================\n   Contrats AC groupés par lot\n   ========================================= */\n\n.contrats-lot-group {\n  margin-bottom: 1.5rem;\n}\n\n.contrats-lot-group:last-child {\n  margin-bottom: 0;\n}\n\n.contrats-lot-header {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #374151;\n  margin: 0 0 0.75rem 0;\n  padding-bottom: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Lien \"Voir les départements/régions\" */\n.lot-zones-link {\n  background: none;\n  border: none;\n  color: #f97316;\n  font-size: 1.2rem;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n  white-space: nowrap;\n}\n\n.lot-zones-link:hover {\n  color: #ea580c;\n}\n\n/* Modale zones géographiques */\n.lot-zones-modal {\n  background: #ffffff;\n  border-radius: 0.75rem;\n  padding: 2rem;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.lot-zones-modal-title {\n  font-size: 1.6rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0 0 0.5rem 0;\n}\n\n.lot-zones-modal-subtitle {\n  font-size: 1.3rem;\n  color: #6b7280;\n  margin: 0 0 1.5rem 0;\n  font-style: italic;\n}\n\n.lot-zones-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 1.5rem 0;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.5rem;\n}\n\n.lot-zones-item {\n  font-size: 1.3rem;\n  color: #374151;\n  padding: 0.5rem 0.75rem;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n}\n\n.lot-zones-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.contrats-lot-departements {\n  font-size: 1.2rem;\n  color: #6b7280;\n  margin: 0 0 0.75rem 0;\n  line-height: 1.5;\n}\n\n\n.document-section .section-content {\n  border: 1px solid #e5e7eb;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
